<div
  (keydown.arrowdown)="onArrowDown($any($event))"
  (keydown.arrowup)="onArrowUp($any($event))"
  (keydown.enter)="onEnter()"
>
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      variant="plain"
      iconName="arrow-back"
      shape="square"
      size="small"
      (click)="$event.preventDefault(); backButtonClick.emit($event)"
    ></rt-icon-button>
    <span>{{ 'tlc.admin_dropdown.switch_company' | translate }}</span>
  </rt-dropdown-header>

  @if (members().length > 4) {
    <rt-form-field (click)="$event.preventDefault()" class="context-default" padding-small>
      <rt-input
        [placeholder]="'tlc.admin_dropdown.search_placeholder' | translate"
        [autoFocus]="true"
        [hasClearButton]="true"
        variant="rounded"
        [formControl]="searchControl"
        (reset)="cancelSearch()"
      >
        <rt-icon prefix name="search"></rt-icon>
      </rt-input>
    </rt-form-field>
  }

  <div #companiesList tabindex="0" rtScrollable class="companies-list">
    @for (member of filteredMembers(); track trackById(i, member); let i = $index) {
      <rt-dropdown-item
        #items
        (click)="changeCompany(member)"
        [isSelected]="this.currentCompany()?.guid === member?.org?.guid"
        [highlighted]="selectedIndex === i"
        class="item-wrap"
      >
        <rt-avatar
          [type]="'initials'"
          [size]="'small'"
          [shape]="'square'"
          [initials]="member.org.name[0]"
          [isColorized]="true"
          class="company-select-avatar"
          prefix
        >
        </rt-avatar>
        <div class="company-name-wrap">
          <span class="company-name">{{ member.org.name }}</span>
        </div>
      </rt-dropdown-item>
    }
  </div>
  <rt-divider></rt-divider>
  @if (canAddNewCompany()) {
    <rt-dropdown-item (click)="newCompanyClick()">
      <rt-icon prefix name="add"></rt-icon>
      {{ 'tlc.admin_dropdown.new_account' | translate }}
    </rt-dropdown-item>
  }

  <rt-dropdown-item (click)="manageCompaniesClick()">
    <rt-icon prefix name="settings"></rt-icon>
    {{ 'tlc.admin_dropdown.manage' | translate }}
  </rt-dropdown-item>
</div>
